import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';
import { BookingsResponse, CreateBookingRequest, BookingsFilters } from '../types/Booking';

const API_BASE_URL = process.env.REACT_APP_API_ENDPOINT || 'https://1m7gmv1b22.execute-api.us-east-2.amazonaws.com/prod';

const api = axios.create({
  baseURL: API_BASE_URL,
});

export const createBooking = async (booking: CreateBookingRequest): Promise<any> => {
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString() || '';

  const response = await api.post('/bookings', booking, {
    headers: {
      'Authorization': token,
      'Content-Type': 'application/json',
    },
  });

  return response.data;
};

export const getBookings = async (filters?: BookingsFilters): Promise<BookingsResponse> => {
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString() || '';

  const params = new URLSearchParams();
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, String(value));
      }
    });
  }

  const response = await api.get(`/bookings?${params}`, {
    headers: {
      'Authorization': token,
    },
  });

  return response.data;
};

export const updateBookingConfirmation = async (
  showDateTime: string,
  comicEmail: string,
  confirmed: boolean
): Promise<any> => {
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString() || '';

  // URL encode the path parameters
  const encodedShowDateTime = encodeURIComponent(showDateTime);
  const encodedComicEmail = encodeURIComponent(comicEmail);

  const response = await api.put(
    `/bookings/${encodedShowDateTime}/${encodedComicEmail}`,
    { confirmed },
    {
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
      },
    }
  );

  return response.data;
};

export const deleteBooking = async (
  showDateTime: string,
  comicEmail: string
): Promise<any> => {
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString() || '';

  // URL encode the path parameters
  const encodedShowDateTime = encodeURIComponent(showDateTime);
  const encodedComicEmail = encodeURIComponent(comicEmail);

  const response = await api.delete(
    `/bookings/${encodedShowDateTime}/${encodedComicEmail}`,
    {
      headers: {
        'Authorization': token,
      },
    }
  );

  return response.data;
};

export const updateBookingAmountPaid = async (
  showDateTime: string,
  comicEmail: string,
  amountPaid: number
): Promise<any> => {
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString() || '';

  // URL encode the path parameters
  const encodedShowDateTime = encodeURIComponent(showDateTime);
  const encodedComicEmail = encodeURIComponent(comicEmail);

  const response = await api.put(
    `/bookings/${encodedShowDateTime}/${encodedComicEmail}`,
    { amount_paid: amountPaid },
    {
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
      },
    }
  );

  return response.data;
};

export const updateBookingSetLength = async (
  showDateTime: string,
  comicEmail: string,
  setLength: number
): Promise<any> => {
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString() || '';

  // URL encode the path parameters
  const encodedShowDateTime = encodeURIComponent(showDateTime);
  const encodedComicEmail = encodeURIComponent(comicEmail);

  const response = await api.put(
    `/bookings/${encodedShowDateTime}/${encodedComicEmail}`,
    { set_length: setLength },
    {
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
      },
    }
  );

  return response.data;
};

export const reorderLineup = async (
  showDateTime: string,
  lineup: Array<{ comic_email: string; order: number }>
): Promise<any> => {
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString() || '';

  const response = await api.post(
    `/bookings/reorder`,
    {
      show_date_time: showDateTime,
      lineup: lineup,
    },
    {
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
      },
    }
  );

  return response.data;
};
